import { render, staticRenderFns } from "./pengeluaran-classification-modal.vue?vue&type=template&id=0894b386&"
import script from "./pengeluaran-classification-modal.vue?vue&type=script&lang=js&"
export * from "./pengeluaran-classification-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports